import axiosInstance from "@/api/axios-instance";

export async function verifyPaymentId(payment_id: string) {
  const response = await axiosInstance.post("/usage/verify-payment-id", { payment_id });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Payment verification failed");
  }

  return response.data; 
}
